import { api } from "../../api"

export async function sendForm(body) {
    let response: any
    response = await api("forms", { method: "POST" }, { formular: body })
    return response
}
